import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRecord from './record.reducer';

export const selectRecordState = createFeatureSelector<fromRecord.RecordState>(fromRecord.recordsFeatureKey);

export const selectAllRecords = createSelector(
  selectRecordState,
  fromRecord.selectAll
);
